export function blobToDataURL(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(typeof reader.result === 'string' ? reader.result : reader.result.toString());
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
}